import { render } from "./Partners.vue?vue&type=template&id=36c68a02&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=36c68a02&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c68a02"]])

export default __exports__